const Strate4TinyBlocksRow = {
    init() {
        const breakpointResponsive = 1140;
        const strate = $('.strate-4-tiny-blocks-row');
        
        if (strate) {
            const sliderItem = $('.strate-4-tiny-blocks-row .inner_content_strate_4_tiny_blocks_row .wrapper_bottom .tiny_block');
            const sliderWrapper = $('.strate-4-tiny-blocks-row .inner_content_strate_4_tiny_blocks_row .wrapper_bottom');
            
            if ($(window).width() < breakpointResponsive) {
                if (sliderItem.length > 1) {
                    Strate4TinyBlocksRow.build(sliderWrapper);
                }
            }
    
            $(window).resize(
                function () {
                    if ($(window).width() < breakpointResponsive) {
                        if (sliderItem.length > 1) {
                            Strate4TinyBlocksRow.build(sliderWrapper);
                        }
                    } else {
                        if (sliderItem.length > 1) {
                            Strate4TinyBlocksRow.destroy(sliderWrapper);
                        }
                    }
                }
            );
        }
    },

    build(sliderWrapper) {
        sliderWrapper = sliderWrapper.addClass('owl-carousel');

        sliderWrapper.owlCarousel(
            {
                loop: true,
                margin: 35,
                items: 1,
                center: true,
                nav: false,
                dots: true,
                stagePadding: 0,
                autoWidth: true,
            }
        );
    },

    destroy(sliderWrapper) {
        sliderWrapper.trigger('destroy.owl.carousel');
        sliderWrapper.removeClass('owl-carousel');
    },
};

export default Strate4TinyBlocksRow;
